type FilterFn = (args: unknown[]) => boolean;

const warnFilters: Map<string, { filter: FilterFn; seen: boolean }> = new Map();

const originalWarn = console.warn;

let isInstalled = false;

/**
 * Install the console filter. Call this once at app startup.
 */
export function installConsoleFilter(): void {
  if (isInstalled) return;
  isInstalled = true;

  console.warn = (...args: unknown[]) => {
    for (const entry of warnFilters.values()) {
      if (entry.filter(args)) {
        if (!entry.seen) {
          entry.seen = true;
          originalWarn.apply(console, args);
          originalWarn.apply(console, [' ↳ ⚠️ [console filter] will mute next instances of this warning']);
        }
        return;
      }
    }
    originalWarn.apply(console, args);
  };
}

/**
 * Add a warning filter. Returns a cleanup function to remove the filter.
 * The first matching warning is shown, followed by a mute notice. Subsequent matches are suppressed.
 * @param id Unique identifier for this filter
 * @param filter Function that returns true to suppress the warning
 */
export function addWarnFilter(id: string, filter: FilterFn): () => void {
  warnFilters.set(id, { filter, seen: false });
  return () => warnFilters.delete(id);
}

/**
 * Remove a warning filter by id.
 */
export function removeWarnFilter(id: string): void {
  warnFilters.delete(id);
}

/**
 * Helper to create a filter that matches warnings containing a substring.
 */
export function containsFilter(substring: string): FilterFn {
  return (args) => typeof args[0] === 'string' && args[0].includes(substring);
}
